import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    private router: Router,
    private _auth: AuthService
  ) { }

  ngOnInit() {

  }

  hasPermissions(role) {
    return this._auth.hasPermissions(role);
  }

  signout() {
    this._auth.logout()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts